import Vue from 'vue'
import VueRouter from 'vue-router'
import FrontLayout from '@/layouts/FrontLayout.vue'
import AdminLayout from '@/layouts/AdminLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: FrontLayout,
    children: [
      { path: '', name: 'Home', component: () => import('@/views/front/Home.vue'), meta: { title: '首页' } },
      { path: 'about', name: 'About', component: () => import('@/views/front/About.vue'), meta: { title: '公司介绍' } },
      { path: 'products', name: 'Products', component: () => import('@/views/front/Products.vue'), meta: { title: '产品服务' } },
      { path: 'honors', name: 'Honors', component: () => import('@/views/front/Honors.vue'), meta: { title: '荣誉展示' } },
      { path: 'news', name: 'News', component: () => import('@/views/front/News.vue'), meta: { title: '新闻动态' } },
      { path: 'news/:id', name: 'NewsDetail', component: () => import('@/views/front/NewsDetail.vue'), meta: { title: '新闻详情' } },
      { path: 'qna', name: 'Qna', component: () => import('@/views/front/Qna.vue'), meta: { title: '一问一答' } },
      { path: 'contact', name: 'Contact', component: () => import('@/views/front/Contact.vue'), meta: { title: '联系我们' } }
    ]
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/Login.vue'),
    meta: { title: '后台登录' }
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/admin/Dashboard.vue'), meta: { title: '仪表盘' } },
      { path: 'home-manage', name: 'HomeManage', component: () => import('@/views/admin/HomeManage.vue'), meta: { title: '首页管理' } },
      { path: 'about-manage', name: 'AboutManage', component: () => import('@/views/admin/AboutManage.vue'), meta: { title: '公司介绍管理' } },
      { path: 'product-manage', name: 'ProductManage', component: () => import('@/views/admin/ProductManage.vue'), meta: { title: '产品服务管理' } },
      { path: 'honor-manage', name: 'HonorManage', component: () => import('@/views/admin/HonorManage.vue'), meta: { title: '荣誉展示管理' } },
      { path: 'news-manage', name: 'NewsManage', component: () => import('@/views/admin/NewsManage.vue'), meta: { title: '新闻动态管理' } },
      { path: 'qna-manage', name: 'QnaManage', component: () => import('@/views/admin/QnaManage.vue'), meta: { title: '一问一答管理' } },
      { path: 'contact-manage', name: 'ContactManage', component: () => import('@/views/admin/ContactManage.vue'), meta: { title: '联系我们管理' } },
      { path: 'teacher-manage', name: 'TeacherManage', component: () => import('@/views/admin/TeacherManage.vue'), meta: { title: '师资团队管理' } },
      { path: 'user-manage', name: 'UserManage', component: () => import('@/views/admin/UserManage.vue'), meta: { title: '用户管理' } },
      { path: 'settings', name: 'Settings', component: () => import('@/views/admin/Settings.vue'), meta: { title: '系统设置' } },
      { path: 'manual', name: 'Manual', component: () => import('@/views/admin/Manual.vue'), meta: { title: '用户操作手册' } }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title ? to.meta.title + ' - ' : '') + '千帆学堂'
  if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
    const token = localStorage.getItem('admin_token')
    if (!token) {
      next({ name: 'AdminLogin' })
      return
    }
  }
  next()
})

export default router
